import { PageHandler } from 'components/ContentHandlers'
import { generateWebPageProps } from 'utils/next'
import { setPageCacheControlHeaders } from 'utils/cache'
import { ArticlesFilterProvider } from 'providers/ArticlesFilterProvider'

export async function getServerSideProps(context) {
  setPageCacheControlHeaders(context.res)
  const serverSideProps = await generateWebPageProps(context)

  serverSideProps?.props?.content?.fields?.sections?.map((section) => {
    if (section?.fields?.fieldName == 'FeaturedPressCarousel') {
      section.fields.sectionContents.push({
        fields: {
          fieldName: 'articleType',
          type: 'article',
          filter: null,
        },
      })
    }
  })

  return serverSideProps
}

export default function Learn({ content, isMobile }) {
  return (
    <ArticlesFilterProvider>
      <PageHandler pageContent={content} isMobileUA={isMobile} />
    </ArticlesFilterProvider>
  )
}
